import script from "./HeaderSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderSearch.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderSearch.vue?vue&type=style&index=0&id=3eba4b51&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/test-saas-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eba4b51"]])

export default __exports__